import { BrowserRouter, Route, Routes } from 'react-router'
import { ModalGameGoldMiner } from '../components/games/modal-game-gold-miner'
import { notifyCloseGame } from '../commom/rn-bridge'

// zurylive: projeto próprio do Gold Miner (Pages gold-miner-video / -dev), no
// padrão dos outros jogos do zury. No didder este código veio de uma cópia do
// webview inteiro; aqui só fica a rota do jogo.

function DirectGoldMinerRoute() {
  // X de fechar: o gold miner roda em iframe dentro do profile-games; avisamos
  // o host pra abrir o modal de confirmação de fechar (mesmo padrão dos slots).
  const handleCloseModal = () => {
    notifyCloseGame()
  }

  return <ModalGameGoldMiner handleCloseModal={handleCloseModal} />
}

export function Router() {
  return (
    <div className="w-screen h-screen bg-transparent font-[Nunito]">
      <BrowserRouter>
        <Routes>
          {/* ${gold-miner}/?token=${token}&liveId=${liveId} */}
          <Route path="/" element={<DirectGoldMinerRoute />} />
          {/* alias antigo: ${webview}/gold-miner?token=${token} */}
          <Route path="/gold-miner" element={<DirectGoldMinerRoute />} />
        </Routes>
      </BrowserRouter>
    </div>
  )
}
